<template>
  <app-layout>
    <template v-slot:headerTitle>
         <p class="text-black">Settings </p>
    </template>
     <template v-slot:tallystatus>
          <div  v-show="tally_open_status=='false'">
                <i class="fa fa-times refresh" aria-hidden="true" ></i>
          </div>
           <div  v-show="tally_open_status=='true'">
                <i class="fas fa-check refresh" aria-hidden="true" ></i>
          </div>
     </template>
     <template v-slot:headerNav>
             <nav-items></nav-items>
     </template>
    <!-- <PageTitle :headerTitle="title"> </PageTitle> -->
         <h4 class="ml-14 pl-14 ">Add-ons</h4>
          <div v-for="(v_e,k_E) in extensionSettingJson" class="max-w-7xl mx-auto sm:px-6 lg:px-8 pt-3 ">
                    <div class="w-full">
                      <div class="bg-white shadow-md rounded px-4 py-2  ">
                      <div class="grid grid-cols-3 gap-4">
                        <div class="col-span-2 ...">
                          <div class="grid grid-cols-3 gap-4 d-flex">
                              <div class="flex items-center  ">
                          <div class="relative w-12 h-12 flex-shrink-0">
                  <div class="absolute  w-full mt-2 text-4xl text-green-400 flex ">
                      <i class="fab fa-font-awesome "></i>                               
                  </div>                       
                  </div>
                  </div> 
                    <div class="col-span-2 ...">                        
                  <div class="">                            
                    <p class="text-sm ">{{v_e.menu_name}}</p>                          
                    <p class="text-sm text-gray-500 ">{{v_e.description}}</p>                      
                    <p class="text-sm text-gray-500">{{v_e.version}}</p>                            
                  </div>
                  </div>
                          </div>
                        </div>
                        <div class="items-center flex justify-end">
                          <label @click="label_check" class="switch" >
                          <input type="checkbox"   :checked="(v_e.status == 'enable'?true:false)"   @change="check($event,v_e)">
                          <span class="slider-green round" ></span>
                        </label>
                        &nbsp; &nbsp; 
                        <jet-nav-link   id="home"  @click="goTosettingDetails(v_e)" :class="(v_e.status == 'enable')?'w-0  next_page':'w-0 isDisabled next_page'"  >
                        <p> <li class="arrow">
                        </li>
                        </p>
                        </jet-nav-link>
                        </div>
                      </div>
                      </div>
                    </div>
          </div>
  </app-layout>
</template>
<script>  
import navItems from "@include/pages/modules/Components/nav_items";
import extensionSettingsJson from '../../../../../Products/Tallyclinic/Data/Json/extensionSettings.json';
import JetNavLink from '@/Jetstream/NavLink.vue';
import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import DxTextBox from 'devextreme-vue/text-box';
import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
} from 'devextreme-vue/form';
const modelData = {};
export default {
  props: {
    createDef: Array,
    moduleRoute: String,
    moduleName:  String,
    modelData:{
        type: Object,
        default: () => ({})
    },
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxTextBox,
    JetNavLink,
    navItems
  },
  computed:{
        valueString() {
            let mod = JSON.stringify(this.extensionSettingJson, null, 2);
            return mod;
        },
  },
  data(){
    return{
      extensionSettingJson:extensionSettingsJson,
      breadcrumbs:['dashboard','integrates.index','configurations.settings']
    }
  },
  methods:{
      goTosettingDetails(data){
           this.$inertia.get(route('configurations.settings_info'),{"data":data})
      },
      check(event,data){
          if(event.path[0].checked==true){
            data.status= "enable";
          }
          else{
            data.status= "disable";
          }
          data.settings = [];
          data.settings.push({"add_on_name":data.add_on_name,"version":data.version,"menu_name":data.menu_name,"description":data.description,"status":data.status})
       
     },
      label_check(e){
          
          var label_parent = e.target.parentElement.parentElement;
          
          var checkbox_value = label_parent.children[0].children[0];
        
          if(checkbox_value.checked == true){
              label_parent.children[1].classList.remove('isDisabled');
          }
          else{
              label_parent.children[1].classList.add('isDisabled');
          }
      }
  },
  mounted(){
// checkbox jqury start
//  $('.switch').on('click',function(){
//    var label_parent = $(this).parent();
 
//   var checkbox_val =label_parent.find('input:checkbox')
  
//   if (checkbox_val.checked == true) {
//     label_parent.find('.next_page').removeClass('isDisabled')
//   } 
//   else{  
//     //   console.log( label_parent.find('input:checkbox').val());
//     label_parent.find('.next_page').addClass('isDisabled')
//   }
//  })
// checkbox jquery end
  } 
}   
</script>
<style>
li {
  border: none!important;
}
.main-content {
  background-color: #f3f4f6;
  /* width: calc(100% - 250px); */
  /* height: 100vh; */
  margin-left: 212px;
  padding-bottom: 10px;
} 
/* .edit_view{
height: 84vh;
} */
.container {
  margin-top:1rem;
}
p{
  margin-bottom: 0px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch input {display:none;}
/*green
-----------------------------------
*/
.slider-green {
  position: absolute;
  cursor: pointer;
  top: 6px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #b8f1dd;
  -webkit-transition: .4s;
  transition: .4s;
}
.slider-green:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
input:checked + .slider-green {
  background-color: #3cd49d;
}
input:focus + .slider-green {
  box-shadow: 0 0 1px #3cd49d;
}
input:checked + .slider-green:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
/* Rounded sliders */
.slider-green.round {
  border-radius: 34px;
}
.slider-green.round:before {
  border-radius: 50%;
}
li {
  border: solid rgb(141, 141, 141);
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 5px;
  cursor: pointer;
}
.arrow {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}
.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
  pointer-events: none;
}
</style>